import { useState } from 'react'
import { useMsal, useIsAuthenticated } from '@azure/msal-react'
import { Navigate } from 'react-router-dom'
import { loginRequest, peekAuthError, clearAuthError, clearInteractiveAttempt } from '@/auth'
import { Button } from '@/components/ui/button'
import { BrandLogo } from '@/components/BrandLogo'
import { LoginBrandPanel } from '@/components/LoginBrandPanel'
import gridIconUrl from '@/assets/login-grid-icon.svg'
import gridIconWhiteUrl from '@/assets/login-grid-icon-white.svg'

export function LoginPage() {
  const { instance } = useMsal()
  const isAuthenticated = useIsAuthenticated()
  const [error, setError] = useState(() => peekAuthError() ?? '')

  if (isAuthenticated) {
    return <Navigate to="/" replace />
  }

  const handleLogin = async () => {
    setError('')
    clearAuthError()
    clearInteractiveAttempt()
    try {
      await instance.loginRedirect(loginRequest)
    } catch (err) {
      setError(
        err instanceof Error
          ? err.message
          : 'Login failed. Please check your credentials and try again.'
      )
    }
  }

  return (
    <div className="flex min-h-screen gap-6 bg-page p-6">
      {/* Left Panel */}
      <div className="flex flex-1 flex-col justify-center px-2">
        <div className="mx-auto w-full max-w-[404px] space-y-8">
          {/* Logo */}
          <BrandLogo variant="full" className="h-16 w-auto" />

          {/* Heading */}
          <div className="space-y-2">
            <h1 className="text-[2rem] font-bold leading-[1.3] tracking-[0.015em]">Log in</h1>
            <p className="text-sm text-muted-foreground tracking-[0.015em]">Log in to manage your projects</p>
          </div>

          {/* Form */}
          <div className="space-y-6">
            {error && (
              <p className="text-sm text-destructive" role="alert" data-testid="login-error">{error}</p>
            )}

            <Button
              onClick={() => handleLogin()}
              className="h-12 w-full font-bold tracking-[0.015em]"
              size="lg"
            >
              <img src={gridIconWhiteUrl} alt="" className="size-5 shrink-0 dark:hidden" />
              <img src={gridIconUrl} alt="" className="hidden size-5 shrink-0 dark:block" />
              Continue with Microsoft
            </Button>
          </div>

        </div>
      </div>

      {/* Right Panel */}
      <LoginBrandPanel className="hidden lg:block lg:flex-1" />
    </div>
  )
}
